module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"MALE":"Male","FEMELLE":"Femelle","HONGRE":"Hongre","INCONNU":"Inconnu"}}')
  delete Component.options._Ctor
}
